// extracted by mini-css-extract-plugin
export default {"content":"page-not-found_content__yMIlb","section":"page-not-found_section__IHuI1","parentContainer":"page-not-found_parentContainer__byZoV"};